export class Coordenadas
{
    Latitude: number;
    Longitude: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/resultado-pesquisa/coordenadas.ts
 **/